/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import CommonPaths from './paths'
import EnquetePaths from './Corporativo/Enquete/paths'
import OnboardingPaths from './Onboarding/Colaborador/paths'
import ControleAcessoPaths from './Controle-Acesso/paths'
import SitemasInternosPaths from './Sistemas-Internos/paths'
import IntegracoesPaths from './Integracoes/paths'

function route (path, view, name, meta) {
    let metadata = {
        requiresAuth: true, 
        role: [], 
        title: null
    }

    if(meta != undefined && meta != null){
        if(meta.role != undefined && meta.role != null){
            for(let i in meta.role)
                metadata.role.push(meta.role[i]); 
        }

        if(meta.requiresAuth != null && !meta.requiresAuth)
            metadata.requiresAuth = false;        

        if(meta.title)
            metadata.title = meta.title;                
    }

    return {
        name: name || view,
        path,
        component: (resolve) => import(
            `@/views/${view}.vue`
        ).then(resolve), 
        meta: metadata
    }
}

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: CommonPaths.map(path => route(path.path, path.view, path.name, path.meta))
            .concat(EnquetePaths.map(path => route(path.path, path.view, path.name, path.meta)))
            .concat(OnboardingPaths.map(path => route(path.path, path.view, path.name, path.meta)))
            .concat(ControleAcessoPaths.map(path => route(path.path, path.view, path.name, path.meta)))
            .concat(SitemasInternosPaths.map(path => route(path.path, path.view, path.name, path.meta)))
            .concat(IntegracoesPaths.map(path => route(path.path, path.view, path.name, path.meta)))
            .concat([ { path: '*', redirect: '/pagina-nao-encontrada' } ]),
            
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) 
            return savedPosition;

        if (to.hash) 
            return { selector: to.hash };

        return { x: 0, y: 0 }
    }
})

router.beforeEach(
    async (to, from, next) => {
        const security = Vue.prototype.$security;
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const roles = to.matched.some(record => record.meta.role);
        
        if (requiresAuth) {
            const user = await security.getUser().catch(
                (err) => {
                    security.signIn();
                }
            );

            if(user == null){
                window.localStorage.setItem("route", to.fullPath);
                security.signIn();
            }
            else{
                const toRoute = window.localStorage.getItem("route");
                if(toRoute != null && toRoute != undefined){
                    window.localStorage.removeItem("route");
                    next();

                    if(toRoute != "/")
                        next(toRoute);
                }
                else{
                    next();
                }                
            }
        } 
        else {
            next();
        }
    }
);

Vue.use(Meta)
export default router